import styled from 'styled-components';

export const SearchButton = styled.div`
  border: 1px solid #e2e8f0;
  width: 100%;
  border-radius: 14px;
  background-color: #f8fafc80;
  margin: 20px 0;
  height: 75px;
  padding: 15px;

  > div {
    width: max-content;

    .action-button {
      max-height: 38px;
      max-width: 120px;
      font-size: 12px;
      color: #212529;
      font-style: normal;
      line-height: normal;

      img {
        color: white;
      }
    }
  }
`;

export const InputWrapper = styled.div`
  border: 1px solid #e2e8f0;
  width: 100%;
  border-radius: 14px;
  background-color: #ffffff;
  display: flex;
  gap: 15px;
  padding: 15px;
  align-items: center;
  position: relative;

  > div {
    min-height: 0;
  }

  .input {
    color: #6c757d;
  }
  label {
    color: #6c757d;
    font-weight: 700;
  }

  @media (max-width: 910px) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
  }
`;

export const TableContainer = styled.div`
  margin-top: 15px;
  margin-left: 15px;
  border-radius: 14px;
`;

export const ClearAllRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  @media (max-width: 910px) {
    display: flex;
    gap: 10px;
    width: 100%;
  }
`;

export const ClearAllColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

export const ClearAllText = styled.span`
  color: #1d3557;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  margin-top: 60px;
`;

export const Icon = styled.img`
  width: 15px;
  height: 15px;
`;

export const ConfigureButton = styled.button`
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #ccc;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 113px;
  height: 32px;
  cursor: pointer;
  box-shadow: 0px 1px 2px -1px #0000001a;
  box-shadow: 0px 1px 3px 0px #0000001a;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  border-radius: 20px;
  border: ${({ $isActive }) => ($isActive ? '1px solid #15C7A7' : 'none')};
  background: ${({ $isActive }) => ($isActive ? '#FFFFFF' : '#F8FAFC')};
  width: fit-content;
`;

export const StatusText = styled.span`
  color: ${({ $isActive }) => ($isActive ? '#15C7A7' : '#62748E')};
  font-size: 14px;
  font-weight: 500;
`;

export const TableWrapper = styled.div`
  margin-top: 20px;
`;

export const MobileExpandedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 0;
`;

export const MobileItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MobileLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
`;

export const MobileValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`;

export const MobileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background: #f8fafc;
  border-radius: 14px;
  border: 1px dashed #e2e8f0;
`;

export const EmptyStateTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #334155;
`;

export const EmptyStateText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #64748b;
`;
